/**
 * fetch() with an AbortController timeout.
 * Drop-in replacement for fetch() — same signature, same return type.
 * Default timeout matches the api.ts global (12 s).
 */
export function fetchWithTimeout(
  url: string,
  options: RequestInit = {},
  timeoutMs = 12_000
): Promise<Response> {
  const controller = new AbortController();
  const callerSignal = options.signal;
  const abortFromCaller = () => controller.abort(callerSignal?.reason);
  if (callerSignal?.aborted) {
    abortFromCaller();
  } else {
    callerSignal?.addEventListener("abort", abortFromCaller, { once: true });
  }
  const id = setTimeout(() => {
    controller.abort(
      new DOMException(`Request timed out after ${timeoutMs}ms: ${url}`, "TimeoutError")
    );
  }, timeoutMs);
  return fetch(url, { ...options, signal: controller.signal }).finally(() => {
    clearTimeout(id);
    callerSignal?.removeEventListener("abort", abortFromCaller);
  });
}
